import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: ${({ theme }) => theme.colors.bgSurface};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.shadow.lg};
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  animation: ${fadeInUp} 400ms cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 32px 24px;
    box-shadow: ${({ theme }) => theme.shadow.md};
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Eyebrow = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 14.5px;
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.5;
`;

export const Footer = styled.footer`
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  text-align: center;
`;

export const Divider = styled.span`
  display: inline-block;
  margin: 0 6px;
  color: ${({ theme }) => theme.colors.border};
`;
